import type { Variant } from '@storefront/lib-global/codegen/types';
import { removeDuplicateReducer } from './removeDuplicateReducer';

export const buildUniqueSizes = (variantsInput: Variant[]): string[] =>
  [...variantsInput]
    .sort((a, b) => (a.globalSize ?? '').localeCompare(b.globalSize ?? ''))
    .reduce(removeDuplicateReducer('size'), []);
